import { PREFERENCES_ROUTES } from '../../constants/_routes'
import preferencesTypes from '../../constants/preferencesTypes'
import { axios } from '../../services'

// INDEX
const preferences_index_request = () => {
  return {
    type: preferencesTypes.index.request
  }
}

const preferences_index_success = (response) => {
  return {
    type: preferencesTypes.index.success,
    payload: response.data
  }
}

const preferences_index_failure = (messages) => {
  return {
    type: preferencesTypes.index.failure,
    payload: messages
  }
}

const preferences_index = () => {
  return function (dispatch) {
    // Before Request
    dispatch(preferences_index_request())

    // Request
    axios.get(
      PREFERENCES_ROUTES.index
    ).then( response => {
      // success
      dispatch( preferences_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching preferences."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( preferences_index_failure(errors))
    })
  }

}

export {
  preferences_index
}



// WEBPACK FOOTER //
// ./src/js/actions/preferences/getindex.js